import styled from "styled-components";
import tw from "twin.macro";

const PullQuoteBlock = styled.aside`
   ${tw`font-mono text-blue-600`}
    border-top: 5px solid #0071ba;
    border-bottom: 5px solid #0071ba;
    padding-top: 20px;
    padding-bottom: 20px;
    width: 300px;
    height: auto;
    margin: 0 auto;
    margin-top: 18px;
    margin-bottom: 18px;
    .copy {
        font-size: 22px;
    }
    .by {
        color: #000;
        font-family: sans-serif;
        font-size: 14px;
        font-style: normal;
    }
    @media (max-width: 799px) {
        width: 100%;
        max-width: 420px;
        display: block;
        margin: 30px auto;
    }
    @media (min-width: 800px) {
        float: ${(props) => props.alignment};
        margin-${(props) =>
          props.alignment === "right" ? "left" : "right"}: 20px;
    }    
`;
const PullQuote = ({ quote, author, alignment }) => {
  return (
    <PullQuoteBlock alignment={alignment} className={alignment}>
      <blockquote className="copy">
        “{quote}” <span className="by"> {author}</span>
      </blockquote>
    </PullQuoteBlock>
  );
};
export default PullQuote;
